class DlPageWarmUp extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.container = this.querySelector('.dl-page-warm-up-container');
        this.afterSubscribeStyle = this.dataset.dlAfterSubscribeStyle;
        this.btn = this.querySelector('.dl-page-warm-up-form-button[name="submit_email"]');
        this.input = this.querySelector('.dl-page-warm-up-form-input[name="email"]');

        this.pop = this.querySelector('dl-pop-base-v2');
        this.id = this.dataset.dlId;

        this.videos = this.querySelectorAll('video');
        this.playBtn = this.querySelector('.dl-page-warm-up-media-play-btn');
        this.content = this.querySelector('.dl-page-warm-up-content[data-dl-after-subscribe-style="discount_code"]');
        this.discountCodeContent = this.querySelector('.dl-page-warm-up-discount-code-content');
        this.copyBtn = this.querySelector('.dl-page-warm-up-form-button[name="copy_coupon_code"]');
        this.bindEvents();

        this.checkSubscriptionStatus();

        this.playVideo();
    }

    bindEvents() {
        this.btn?.addEventListener('click', this.btnClick.bind(this));
        this.copyBtn?.addEventListener('click', this.copyCouponCode.bind(this));
        this.playBtn?.addEventListener('click', () => {
            this.playVideo();
        });

        this.videos?.forEach(video => {
            video.addEventListener('ended', () => {
                this.pauseVideo();
            });
        });
    }

    copyCouponCode() {
        let code = this.copyBtn.dataset.dlCode;
        if (copyTextToClipboard(code)) {
            this.copyBtn.innerHTML = this.copyBtn.dataset.dlCopiedText;
            setTimeout(() => {
                this.copyBtn.innerHTML = this.copyBtn.dataset.dlText;
            }, 1000);
        }
    }

    btnClick() {
        let email = this.querySelector('input[name="email"]').value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let isValid = emailRegex.test(email);
        if (!isValid) {
            alert('Please enter a valid email address');
            return;
        }

        if (!braze) {
            alert('Please try again later');
            return;
        }

        try {
            DLPixelH.addToUserArrayProperty('page-subscribed', `${this.id}`);
            DLPixelH.identify(email);
            let braze_lastest_shopify_store = localStorage.getItem('braze_lastest_shopify_store');
            if (!braze_lastest_shopify_store) {
                let subdomain = window.location.hostname.split('.')[0];
                subdomain = subdomain == 'petlibro' || subdomain == 'ca' ? 'us' : subdomain;
                localStorage.setItem('braze_lastest_shopify_store', subdomain);
            }
            let data = {};
            data["page-subscribed"] = `${this.id}`;
            data["email"] = email;
            data["shopify_store"] = braze_lastest_shopify_store;
            DLPixelH.capture('page_subscribed', data);

            console.log('page subscribed', data);
        }
        catch (error) {
            alert('Please try again later');
            return;
        }

        if (this.afterSubscribeStyle == 'discount_code') {
            this.content?.classList.add('hidden');
            this.discountCodeContent?.classList.remove('hidden');
            this.saveSubscriptionStatus();
            this.shakeCopyBtn();
        } else {
            this.pop?.show();
        }
        return;
    }

    playVideo() {
        this.container.classList.remove('dl-pausing');
        let video = window.innerWidth > 990 ? this.querySelector('video.dl-hidden-mobile') : this.querySelector('video.dl-hidden-desktop');
        if (video) {
            video.play();
        }
    }

    pauseVideo() {
        this.container.classList.add('dl-pausing');
        this.videos.forEach(video => {
            video.pause();
        });
    }

    saveSubscriptionStatus() {
        try {
            const storageKey = `warm_up_subscribed_${this.id}`;
            localStorage.setItem(storageKey, 'true');
        } catch (error) {
            console.error('Failed to save subscription status:', error);
        }
    }

    checkSubscriptionStatus() {
        try {
            const storageKey = `warm_up_subscribed_${this.id}`;
            const isSubscribed = localStorage.getItem(storageKey);
            
            if (isSubscribed === 'true' && this.afterSubscribeStyle === 'discount_code') {
                this.content?.classList.add('hidden');
                this.discountCodeContent?.classList.remove('hidden');
            }
        } catch (error) {
            console.error('Failed to check subscription status:', error);
        }
    }

    shakeCopyBtn() {
        if (!this.copyBtn) return;
        setTimeout(() => {
            this.copyBtn.classList.add('dl-shake');
            setTimeout(() => {
                this.copyBtn.classList.remove('dl-shake');
            }, 600);
        }, 300);
    }
}
customElements.define('dl-page-warm-up', DlPageWarmUp);